import * as React from "react";
import { LocationInfo } from "../../shared/models/Location.js";
import Panel from "../Panel";

export interface LocationListProps {
  locations: Array<LocationInfo>;
}

const LocationList = (props: React.PropsWithChildren<LocationListProps>) => {
  const count = props.locations.length;
  return (
    <div className="container">
      <div className="row my-3">
        <div className="col-6 text-left">Showing {count} results</div>
        <div className="col-6 text-right">
          Click on title to select location
        </div>
      </div>
      <div className="row">
        {props.locations.map((location: LocationInfo) => (
          <Panel {...location} key={location.id} />
        ))}
      </div>
    </div>
  );
};

export default LocationList;
